<template>
  <v-card flat>
    <v-data-table hide-actions :items="items" :headers="headers" class="shadow">
      <template slot="items" slot-scope="{ item }">
        <td>
          <v-checkbox
            hide-details
            color="teal"
            :label="item.title"
            @change="onIndexSelect(item.name)"
            v-model="permissions['all_' + item.name].value"
          />
        </td>
        <td>
          <v-checkbox
            hide-details
            color="teal"
            v-show="permissions['all_' + item.name].value"
            v-model="permissions['view_' + item.name].value"
          />
        </td>
        <td>
          <v-checkbox
            hide-details
            color="teal"
            v-show="permissions['all_' + item.name].value"
            v-model="permissions['add_' + item.name].value"
          />
        </td>
        <td>
          <v-checkbox
            hide-details
            color="teal"
            v-show="permissions['all_' + item.name].value"
            v-model="permissions['edit_' + item.name].value"
          />
        </td>
        <td>
          <v-checkbox
            hide-details
            color="teal"
            v-show="permissions['all_' + item.name].value"
            v-model="permissions['delete_' + item.name].value"
          />
        </td>
      </template>
    </v-data-table>
  </v-card>
</template>
<script>
export default {
  name: "permissions",
  props: {
    permissions: {
      default: () => []
    }
  },
  data() {
    return {};
  },
  computed: {
    headers: vm => [
      { text: vm.$t("part"), value: "title", sortable: false },
      { text: vm.$t("view"), value: "s", sortable: false },
      { text: vm.$t("add"), value: "c", sortable: false },
      { text: vm.$t("edit"), value: "e", sortable: false },
      { text: vm.$t("delete"), value: "d", sortable: false }
    ],

    items() {
      if (this.permissions.length < 1) {
        return [];
      } else {
        return [
          { title: this.$t("dashboard"), name: "dashboard" },
          { title: this.$t("questions"), name: "questions" },
          { title: this.$t("assessments"), name: "assessments" },
          { title: this.$t("CSOs"), name: "CSOs" },
          { title: this.$t("projects"), name: "projects" },
          { title: this.$t("workshops"), name: "workshops" },
          { title: this.$t("reports"), name: "reports" },
          { title: this.$t("settings"), name: "settings" },
          { title: this.$t("roles"), name: "roles" },
          { title: this.$t("users"), name: "users" }
          // { title: this.$t("backups"), name: "backups" }
        ];
      }
    }
  },
  methods: {
    onIndexSelect(name) {
      if (!this.permissions["all_" + name]["value"]) {
        this.permissions["add_" + name]["value"] = false;
        this.permissions["edit_" + name]["value"] = false;
        this.permissions["view_" + name]["value"] = false;
        this.permissions["delete_" + name]["value"] = false;
      } else {
        this.permissions["add_" + name]["value"] = true;
        this.permissions["edit_" + name]["value"] = true;
        this.permissions["view_" + name]["value"] = true;
        this.permissions["delete_" + name]["value"] = true;
      }
    }
  }
};
</script>
